"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStarburstPath = void 0;
const constants_1 = require("../../constants");
const utility_paths_1 = require("../utility.paths");
function getStarCoordinates(numberOfPoints, outerRadius, innerRadius) {
    const outerCoordinates = utility_paths_1.getRegularPolygonCoordinates(numberOfPoints, outerRadius);
    const innerCoordinates = utility_paths_1.getRegularPolygonCoordinates(numberOfPoints, innerRadius, (2 * Math.PI) / (2 * numberOfPoints));
    const coordinates = [];
    for (let i = 0; i < 2 * numberOfPoints; i++) {
        coordinates[i] =
            i % 2 === 0
                ? outerCoordinates[i / 2]
                : {
                    x: outerRadius - innerRadius + innerCoordinates[Math.floor(i / 2)].x,
                    y: outerRadius - innerRadius + innerCoordinates[Math.floor(i / 2)].y,
                };
    }
    return coordinates;
}
function getStarburstPath(starBrustShape) {
    let coordinates = [];
    const width = constants_1.SvgDefaults.viewBoxWidth;
    const numberOfPoints = starBrustShape.numberOfPoints;
    const height = starBrustShape.height;
    coordinates = getStarCoordinates(numberOfPoints, width / 2, (height * width) / constants_1.SvgDefaults.viewBoxWidth);
    return utility_paths_1.generatePathFromCoordinates(coordinates);
}
exports.getStarburstPath = getStarburstPath;
//# sourceMappingURL=starburst.js.map